import React, { useEffect, useState } from 'react';
import { Typography, Container, Button, IconButton, CircularProgress, Grid, Paper, Toolbar } from '@material-ui/core'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage  } from 'react-intl'
import MaterialTable from 'material-table';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import { IdentityActions, TerminalActions, NotificationActions } from '../../../store';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

const style = theme => ({
    root: {
        height: '100%'
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const terminalSelector = (state) => state.Terminals;
const IdentitySelector = (state) => state.Identity;

const TerminalList = (props) => {


    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const terminalActions = bindActionCreators(TerminalActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { tlist, nowWainting } = useSelector(terminalSelector);
    const { token, userData, permissions } = useSelector(IdentitySelector);

    const { classes } = props;

    //console.log("userData.role=" + userData.role);

    var shopName = props.shopName;                  // 店舗名
    var terminalType = props.terminalType;          // 端末タイプ
    var terminalId = props.terminalId;              // 端末機識別番号
    var installId = props.installId;                // 機器設置時識別番号
    var machineRwCd = props.machineRwCd;            // 物販端末R/Wコード
    var shopCd4 = props.shopCd4;                    // 店舗識別コード（レベル4）
    var merchantOrgInfo = props.merchantOrgInfo;    // 加盟店独自識別情報
    var isInstalled = props.isInstalled;            // 設置フラグ

    const listDefinition = {
        columns: [
            // 店舗名
            {
                title: <FormattedMessage id="Shop.Name" />,
                field: 'shop_name',
                filtering: true,
                defaultFilter: props.shopName,
            },
            // 端末タイプ
            {
                title: <FormattedMessage id="Terminal.Type" />,
                field: 'terminal_type',
                lookup: {
                    1: "ステッカー",
                    2: "QR",
                    3: "カード",
                    4: "QRカード"
                },
                filtering: true,
                defaultFilter: props.terminalType,
            },
            // 端末機識別番号
            {
                title: <FormattedMessage id="Terminal.Id" />,
                field: 'id',
                filtering: true,
                defaultFilter: props.terminalId,
            },
            // 機器設置時識別番号
            {
                title: <FormattedMessage id="Terminal.InstallId" />,
                field: 'install_id',
                filtering: true,
                defaultFilter: props.installId,
            },
            // 物販端末R/Wコード
            {
                title: <FormattedMessage id="Terminal.MachineRwCd" />,
                field: 'machine_rw_cd',
                filtering: true,
            },
            // 店舗識別コード（レベル4）
            {
                title: <FormattedMessage id="Terminal.ShopCd4" />,
                field: 'shop_cd_4',
                filtering: true,
                defaultFilter: props.shopCd4,
            },
            // 加盟店独自識別情報
            {
                title: <FormattedMessage id="Terminal.MerchantOrgInfo" />,
                field: 'merchant_org_info',
                filtering: true,
                defaultFilter: props.merchantOrgInfo,
            },
            // 設置フラグ
            {
                title: <FormattedMessage id="Terminal.IsInstalled" />,
                field: 'is_installed',
                lookup: {
                    false: "未設置",
                    true: "設置済",
                },
                filtering: true,
                defaultFilter: props.isInstalled,
            },
        ]
    };

    /**
     *
     * フィルター変更時
     *
     * @param filter フィルターデータ配列
     */
    const onChangeFilter = (filter) => {

        shopName = '';
        terminalType = '';
        terminalId = '';
        installId = '';
        machineRwCd = '';
        shopCd4 = '';
        merchantOrgInfo = '';
        isInstalled = '';

        if (filter.length > 0) {
            for (let i = 0; i < filter.length; i++) {
                if (filter[i].column.field == 'shop_name') {
                    shopName = filter[i].value;
                } else if (filter[i].column.field == 'terminal_type') {
                    terminalType = filter[i].value;
                } else if (filter[i].column.field == 'id') {
                    terminalId = filter[i].value;
                } else if (filter[i].column.field == 'install_id') {
                    installId = filter[i].value;
                } else if (filter[i].column.field == 'machine_rw_cd') {
                    machineRwCd = filter[i].value;
                } else if (filter[i].column.field == 'shop_cd_4') {
                    shopCd4 = filter[i].value;
                } else if (filter[i].column.field == 'merchant_org_info') {
                    merchantOrgInfo = filter[i].value;
                } else if (filter[i].column.field == 'is_installed') {
                    isInstalled = filter[i].value;
                }
            };
        }
        //console.log("shopName=" + shopName);
        //console.log("terminalType=" + terminalType);
        //console.log("terminalId=" + terminalId);
        //console.log("machineRwCd=" + machineRwCd);
        //console.log("merchantOrgInfo=" + merchantOrgInfo);
        //console.log("isInstalled=" + isInstalled);
    }

    /**
     *
     * Similar to componentDidMount and componentDidUpdate:
     * 
     * 第2引数に[]を渡すとマウント時のみ呼び出される
     */
    useEffect(() => {
        let shopId = '';
        if (userData.role == 5) {
            // 店舗ユーザの場合は、加盟店IDと店舗IDを指定して端末一覧を取得
            // userData.org_idには店舗IDを保持している
            shopId = userData.org_id;
        }
        if (props.refresh == null || props.refresh == true) {
            // storeに端末リストを要求
            terminalActions.listTerminals(token, props.merchantId, shopId)
                .then(data => {
                })
                .catch(e => {
                    notificationActions.showError(e.message);
                });
        }

    }, []);

    /**
     * 
     * 戻る押下時の処理
     * 
     */
    const onBackClick = (merchantName, merchantType, shopName, terminalType, terminalId, machineRwCd, merchantOrgInfo, isInstalled) => {
        props.onCancel(merchantName, merchantType,shopName, terminalType, terminalId, machineRwCd, merchantOrgInfo, isInstalled);
    }

    /**
     * 
     * 詳細ボタン押下時の処理
     * 
     * @param data 選択された行のデータ 
     */
    const onDetailClick = (data, merchantName, merchantType, shopName, terminalType, terminalId, machineRwCd, merchantOrgInfo, isInstalled) => {
        props.onDetail(data, merchantName, merchantType, shopName, terminalType, terminalId, machineRwCd, merchantOrgInfo, isInstalled);
    }

    /**
     * 
     * 新規ボタン押下時の処理
     * 
     */
    const onCreateClick = (merchantName, merchantType, shopName, terminalType, terminalId, machineRwCd, merchantOrgInfo, isInstalled) => {
        props.onCreate(merchantName, merchantType, shopName, terminalType, terminalId, machineRwCd, merchantOrgInfo, isInstalled);
    }

    const placeholder = <FormattedMessage id="Table.Action" />;

    var backButton = <div></div>;
    if (!(userData.role == 4 || userData.role == 5)) {
        backButton =
            <div style={{ padding: 10 }}>
                <Grid container item xs={12} spacing={2} justify="center">
                    <Grid item xs={3} sm={6}>
                        <Button fullWidth variant="contained" size="medium"
                            startIcon={<ArrowBackIosIcon />}
                            onClick={() => onBackClick(props.merchantNameSearch, props.merchantType, shopName, terminalType, terminalId, machineRwCd, merchantOrgInfo, isInstalled)}><FormattedMessage id="Button.Back" /></Button>
                    </Grid>
                </Grid>
            </div>;
    }

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Toolbar variant="regular">
                    <div>
                        <Typography component="h1" variant="inherit"><FormattedMessage id="Terminal.Title" /></Typography>
                    </div>
                </Toolbar>
            </Paper>
            <MaterialTable
                title={<Typography component="h2" variant="inherit">{props.merchantName}</Typography>}
                onFilterChange={(filter) => onChangeFilter(filter)}
                columns={listDefinition.columns}
                data={tlist}
                options={{
                    search: false,
                    filtering: true,
                    actionsColumnIndex: -1
                }}
                localization={{
                    body: {
                        emptyDataSourceMessage: <FormattedMessage id="Table.EmptyDataSourceMessage" />
                    },
                    header: {
                        actions: ''
                    },
                }}
                components={{
                    Action: actionProps => {
                        if (actionProps.action.tooltip !== "Add") {
                            return (
                                <IconButton aria-label="detail" onClick={() => onDetailClick(actionProps.data, props.merchantNameSearch, props.merchantType, shopName, terminalType, terminalId, machineRwCd, merchantOrgInfo, isInstalled)}>
                                    <ArrowForwardIosIcon />
                                </IconButton>
                            )
                        } else {
                            if (permissions != null && permissions != undefined && permissions.fid5_4 != null && (permissions.fid5_4.value.value & 2) == 2) {
                                // 端末管理の編集権限が付与されているユーザのみ端末追加ボタンを表示
                                return (
                                    <Button onClick={() => onCreateClick(props.merchantNameSearch, props.merchantType, shopName, terminalType, terminalId, machineRwCd, merchantOrgInfo, isInstalled)} variant="contained" color="secondary" size="medium" startIcon={<AddCircleOutlineIcon />} >
                                        <FormattedMessage id="Terminal.Create" />
                                    </Button>
                                )
                            }
                            else {
                                return (
                                    <div></div>
                                )
                            }
                        }
                    }
                }}
                editable={{
                    onRowAdd: newData => { },
                    onRowUpdate: (newData, oldData) => { }
                }}
            />
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}

            {backButton}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(TerminalList);
